export class CompanyConfiguration {
  public id: string;
  public fiscalNumber: string;
  public transactionalLimit: number;
  public changedByExternalUserId: string;
  public createDate: string;
  public lastChangeDate: string;
  public hasTransactionalLimit: boolean;

  public getId(): string {
    return this.id;
  }

  public setId(id: string): void {
    this.id = id;
  }

  public getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  public setFiscalNumber(fiscalNumber: string): void {
    this.fiscalNumber = fiscalNumber;
  }

  public getTransactionalLimit(): number {
    return this.transactionalLimit;
  }

  public setTransactionalLimit(transactionalLimit: number): void {
    this.transactionalLimit = transactionalLimit;
  }

  public getChangedByExternalUserId(): string {
    return this.changedByExternalUserId;
  }

  public setChangedByExternalUserId(changedByExternalUserId: string): void {
    this.changedByExternalUserId = changedByExternalUserId;
  }

  public getCreateDate(): string {
    return this.createDate;
  }

  public setCreateDate(createDate: string): void {
    this.createDate = createDate;
  }

  public getLastChangeDate(): string {
    return this.lastChangeDate;
  }

  public setLastChangeDate(lastChangeDate: string): void {
    this.lastChangeDate = lastChangeDate;
  }

  public isHasTransactionalLimit(): boolean {
    return this.hasTransactionalLimit;
  }

  public setHasTransactionalLimit(hasTransactionalLimit: boolean): void {
    if (!hasTransactionalLimit) {
      this.transactionalLimit = 0;
    }
    this.hasTransactionalLimit = hasTransactionalLimit;
  }
}
